module.exports = __webpack_public_path__ + "img/banner_test_01.56a0a8bb.webp";